$(document).ready(function(){
    // Main Product Media (Main Image Slider)
    $('.main-product__media').slick({
        slidesToShow: 1,
        infinite: true,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: true,
        arrows: true,
        fade: true,
        prevArrow: $(".main-product__left"),
        nextArrow: $(".main-product__right"),
        asNavFor: '.main-product__media-thumbnails' // Ensure same as below
    });

    // Thumbnail Navigation
    $('.main-product__media-thumbnails').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        centerMode: true,
        asNavFor: '.main-product__media', // Ensure same as above
        variableWidth: true,
        focusOnSelect: true, // Enables click selection to sync
        touchMove: true, 
        swipe: true, 
        draggable: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3, // Show 2 thumbnails on mobile
                    slidesToScroll: 1
                }
            }
        ]
    });

    // Force Synchronization Fix
    $('.main-product__media-thumbnails').on('afterChange', function(event, slick, currentSlide){
        $('.main-product__media').slick('slickGoTo', currentSlide);
    });

    $('.main-product__media').on('afterChange', function(event, slick, currentSlide){
        $('.main-product__media-thumbnails').slick('slickGoTo', currentSlide);
    });

    $('.pdp_kodel_verta_carousel').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
    });

    $('.pdp_gerio_kelione_carousel').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        centerPadding: '100px',
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: false
            }
          },
          {
            breakpoint: 678,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false
            }
          }
        ]
    });
    $('.pdp_gerio_kelione_carousel_merch').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        centerMode: false,
        centerPadding: '100px',
        prevArrow: "<button type='button' class='slick-prev pull-left'><img class='left_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG_1.png?v=1724591972'/></button>",
        nextArrow: "<button type='button' class='slick-next pull-right'><img class='right_arrow' src='https://cdn.shopify.com/s/files/1/0573/6182/5865/files/SVG.png?v=1724591971'/></button>",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerMode: false
            }
          },
          {
            breakpoint: 678,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: false
            }
          }
        ]
    });

    $('.pdp_icons_line').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 1000,
        arrows: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 320,
                settings: {
                    slidesToShow: 3
                }
            }
        ] // <- This closing bracket was missing before
    }); // <- And this closing parenthesis

    $('.pdp_accordion_line').click(function(){
        $(this).toggleClass('active');
        $(this).find('.pdp_accordion_info').slideToggle();
    });

    $('.pdp_qty_outer_block').click(function(){
        $('.pdp_qty_outer_block').removeClass('active');
        $(this).addClass('active');

        $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
            var currentId = $(this).val();
            if (currentId == 'pasirink'){
                $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
            }
        });

        if ($(this).attr('data') == 'fizinis'){
            $('.pdp_giftcard_type').attr('value', 'fizinis');
        }
        else{
            $('.pdp_giftcard_type').attr('value', 'elektroninis');
        }
    });

  

  

  $('.pdp_gift_variant_cel').click(function () {
    $('.pdp_gift_variant_cel').removeClass('active');
    $(this).addClass('active');

    var currentId = $(this).attr('data-id');

    // ✓ Update Shopify ATC variant ID
    $('input[name="id"]').val(currentId);

    // ✓ Update dynamic pricing (if used)
    $('.pdp_As_price[data-id]').hide();
    $('.pdp_As_price[data-id="' + currentId + '"]').show();
});

    $('.pdp_select_qty_option__js').change(function(){
        $('.pdp_qty_expanded_main_product').removeClass('needsAttention');
        $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
            var currentId = $(this).val();
            if (currentId == 'pasirink'){
                $(this).closest('.pdp_qty_expanded_main_product').addClass('needsAttention');
            }
        });
    });

    $('.pdp_adding_to_cart_mn_btn').click(function(){
        var data = $('.pdp_qty_outer_block.active').attr('data');
        if (data == '1'){
            $('.main_hidden_atc_btn_to_submit').trigger('click');
        }
        else {
            var items = [];
            $('.pdp_qty_outer_block.active .pdp_select_qty_option__js').each(function(){
                var currentId = $(this).val();
                items.push({ id: currentId, quantity: 1 });
            });

            $.ajax({
                type: "POST",
                url: "/cart/add.js",
                data: {
                    items: items,
                },
                dataType: "json",
                success: function (data) {
                    $('.main_hidden_atc_btn_to_submit').trigger('click');
                },
            }); 
        }
    });
});
